import {api} from "../../../services/api/api.service";

export const loadAccounts = (loading) => api({uri: `/accounts`, loading});